import { PageName } from '@ms/yammer-telemetry-support';

import { PageLoadEventData } from './loadEvents';

let firstLoadedPage: PageName | undefined = undefined;

const precachePages = ['Precache', 'EmptyStart'];
export const isPrecachePage = (page: PageName): boolean => precachePages.includes(page);

export const getFirstLoadedPage = () => firstLoadedPage;

export const updateFirstLoadedPageIfNecessary = ({ page }: PageLoadEventData) => {
  if (!firstLoadedPage) {
    firstLoadedPage = page;

    return;
  }

  if (isPrecachePage(firstLoadedPage)) {
    firstLoadedPage = page;
  }
};

export const debugResetFirstLoadedPage = () => {
  firstLoadedPage = undefined;
};
